import script from "./ClientUserFileDocModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientUserFileDocModal.vue?vue&type=script&setup=true&lang=ts"

import "./ClientUserFileDocModal.vue?vue&type=style&index=0&id=063f10c9&scoped=true&lang=scss"

import exportComponent from "/home/forge/client.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-063f10c9"]])

export default __exports__